import {
  BORDER_RADIUS,
  BORDER_RADIUS_LARGE,
  COLORS,
  DEFAULT_BOX_SHADOW,
  DEFAULT_TRANSITION_ALL,
} from "utils/styles";

import AudienceEmoji from "components/AudienceEmoji";
import { AUDIENCE_TYPES } from "posts/constants";
import IconButton from "components/IconButton";
import React, { useState } from "react";
import styled from "styled-components";
import { useEffect } from "react";
import { getFilenamePrefix } from "utils/files";

const height = 640;
const mobileHeight = 300;

const Wrapper = styled.div`
  height: ${height}px;
  background: ${COLORS.WHITE};

  margin: 0 0 2rem;
  position: relative;
  @media (max-width: 50em) {
    height: ${mobileHeight}px;
  }
`;

const Arrow = styled(IconButton)`
  align-content: center;
  appearance: none;
  background: ${COLORS.WHITE};
  border-radius: 100%;
  border: none;
  display: flex;
  height: 34px;
  justify-content: center;
  margin: 0;
  outline: none;
  padding: 0;
  position: absolute;
  top: ${height / 2 - 5}px;
  @media (max-width: 50em) {
    top: ${mobileHeight / 2 - 5}px;
  }
  width: 34px;

  & i {
    margin-right: 0 !important;
    padding-top: 0.3rem;
  }
`;

const LeftArrow = styled(Arrow)`
  left: 1rem;
`;
const RightArrow = styled(Arrow)`
  right: 1rem;
`;

const AvatarWrapper = styled.div`
  margin: -4.5rem auto 0 auto;
  max-width: 80rem;
  @media (max-width: 50em) {
    margin: -3.5rem auto 0 auto;
  }
`;

const Avatar = styled.div.attrs({ className: "mabry-regular" })`
  ${BORDER_RADIUS_LARGE};
  ${DEFAULT_BOX_SHADOW};
  ${DEFAULT_TRANSITION_ALL};
  background: ${COLORS.WHITE};
  display: inline-block;
  padding: 1rem 1.5rem;
  font-size: 1.5rem;

  @media (min-width: 50em) {
    font-size: 2.25rem;
  }
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${({ image }) => `${image}.png`});
  background-size: contain;
  background-position: center center;
  display: ${({ isActive }) => {
    return isActive ? "block" : "none";
  }};
`;

const BackgroundImageWrapper = styled.div`
  ${BORDER_RADIUS_LARGE}
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

function ProfileBanner({ activeAudience, onChangeAudience }) {
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    setCurrentImage(0);
  }, [activeAudience]);
  const renderImages = () => {
    let prefix = "tough-cookies";
    switch (activeAudience) {
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        prefix = "dont-tread-on-me";
        break;

      case AUDIENCE_TYPES.PEOPLE_POWER:
        prefix = "people-power";
        break;

      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        prefix = "if-you-say-so";
        break;
    }
    return (
      <BackgroundImageWrapper>
        {[1, 2, 3].map((img, i) => {
          return (
            <BackgroundImage
              key={`profile-banner-image-${prefix}-${i}`}
              isActive={i === currentImage}
              image={`/images/profile-banners/${prefix}-${img}`}
            />
          );
        })}
      </BackgroundImageWrapper>
    );
  };

  const handleChangeImage = (value) => {
    if (value === -1 && currentImage === 0) {
      setCurrentImage(2);
    } else {
      setCurrentImage((currentImage + value) % 3);
    }
  };

  return (
    <Wrapper>
      <LeftArrow onClick={() => handleChangeImage(-1)}>
        <i className="material-icons-round mr-2">chevron_left</i>
      </LeftArrow>
      <RightArrow onClick={() => handleChangeImage(1)}>
        <i className="material-icons-round mr-2">chevron_right</i>
      </RightArrow>
      {renderImages()}
      <AvatarWrapper>
        <Avatar>
          <AudienceEmoji audience={activeAudience} />
          {activeAudience}
        </Avatar>
      </AvatarWrapper>
    </Wrapper>
  );
}

export default ProfileBanner;
